import React from 'react';
import styled from 'styled-components';
import {
  fromUnixTime,
  formatDistanceToNow,
  differenceInDays,
  differenceInMonths,
} from 'date-fns';

import ru from 'date-fns/locale/ru';

import { formatDate } from '../../../../utils/date';
import { DATE_FULL_DATE } from '../../../../constants/userflow';

import formatDistance from './locale/formatDistance';

interface ITimeFrom {
  full?: boolean;
  extend?: boolean;
  className?: string;
  time: number;
}

const customLocale = { ...ru, formatDistance };
const UPDATE_INTERVAL = 60 * 1000;

class TimeFrom extends React.PureComponent<ITimeFrom> {
  interval: number | NodeJS.Timeout;

  static getCurrentTime() {
    return Math.round(new Date().getTime() / 1000);
  }

  static getTimeForTitle(time: number) {
    const date = fromUnixTime(time);
    return formatDate(date, DATE_FULL_DATE);
  }

  static getTimeFromNow(time: number) {
    const now = new Date();
    const date = fromUnixTime(time);
    const oneMonthIsOver = differenceInMonths(now, date) > 0;

    const result = formatDistanceToNow(date, {
      locale: customLocale,
    });

    if (oneMonthIsOver) {
      return formatDate(date, 'd MMM yyyy');
    }

    return result;
  }

  static getTimeFullFromNow(time: number, extend) {
    const now = new Date();
    const date = fromUnixTime(time);
    const oneDayIsOver = differenceInDays(now, date) > 1;
    const fullDate = formatDate(date, DATE_FULL_DATE);

    const result = formatDistanceToNow(date, {
      addSuffix: true,
      locale: customLocale,
    });

    if (oneDayIsOver) {
      return fullDate;
    }

    if (extend) {
      return `${result} (${fullDate})`;
    }

    return result;
  }

  constructor(props: ITimeFrom) {
    super(props);

    this.interval = 0;
  }

  componentDidMount() {
    this.interval = setInterval(this.update.bind(this), UPDATE_INTERVAL);
  }

  componentWillUnmount() {
    clearInterval(this.interval as NodeJS.Timeout);
  }

  update() {
    this.forceUpdate();
  }

  render() {
    const { full: isFull = false, extend = false, time, ...props } = this.props;

    if (TimeFrom.getCurrentTime() < time) {
      return null;
    }

    return (
      <StyledTimeFrom title={TimeFrom.getTimeForTitle(time)} {...props}>
        {isFull
          ? TimeFrom.getTimeFullFromNow(time, extend)
          : TimeFrom.getTimeFromNow(time)}
      </StyledTimeFrom>
    );
  }
}

const StyledTimeFrom = styled.div`
  color: #919499;
  cursor: default;
  font-size: 12px;
`;

export default TimeFrom;
